import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import { FormattedMessage, FormattedHTMLMessage } from 'component-utilities/intl';

import ModalContainer from './ModalContainer';
import ModalHeader from './ModalHeader';
import ModalButtons from './ModalButtons';
import ModalContentCenter from './ModalContentCenter';
import ModalText from './ModalText';

export default function UnsavedChangesModal(props) {
    const BASE_KEY = 'components.modals.unsaved_search_changes';
    const { options } = props.modal;

    const shouldSaveBeforeLeave = options ? options.shouldSaveBeforeLeave : true;
    const closeModal = props.onClose || options.closeModal;
    const messagePath = `${BASE_KEY}.message_${shouldSaveBeforeLeave ? 'save' : 'warning'}`;

    return (
        <ModalContainer>
            <ModalHeader withIcon type="warning" onCloseClick={closeModal}>
                <FormattedMessage id={`${BASE_KEY}.title`} />
            </ModalHeader>

            <ModalContentCenter>
                <ModalText>
                    <FormattedHTMLMessage id={messagePath} />
                </ModalText>
            </ModalContentCenter>

            {shouldSaveBeforeLeave && (
                <ModalButtons
                    primaryText={<FormattedMessage id={`${BASE_KEY}.button`} />}
                    onPrimaryClick={closeModal}
                />
            )}
            {!shouldSaveBeforeLeave && (
                <ModalButtons
                    onPrimaryClick={options.onLeave}
                    onSecondaryClick={closeModal}
                    primaryText={<FormattedMessage id="components.buttons.ok" />}
                    secondaryText={<FormattedMessage id="components.buttons.cancel" />}
                />
            )}
        </ModalContainer>
    );
}

UnsavedChangesModal.displayName = displayName('Modals/UnsavedChangesModal');

UnsavedChangesModal.propTypes = {
    onClose: PropTypes.func,
    modal: PropTypes.shape({
        options: PropTypes.shape({
            closeModal: PropTypes.func.isRequired,
            shouldSaveBeforeLeave: PropTypes.bool,
            onLeave: PropTypes.func,
        }).isRequired,
    }),
};

UnsavedChangesModal.defaultProps = {
    onClose: null,
    closeModal: null,
    modal: {},
};
